import React, { useState, useContext, useEffect, useMemo } from 'react'
import { useHistory } from 'react-router'
import { GoInfo } from 'react-icons/go'
import { Form, Row, Col, Button, Accordion, InputGroup, FormControl, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Formik, Field, FieldArray, ErrorMessage } from 'formik'

import api from '../../services/api'
import StoreContext from '../storage/context'
import BtnBack from '../buttons/back/index.js'
import BtnNext from '../buttons/next/index.js'
import TableFields from '../tableFields/index.js'
import BtnLoader from '../buttons/loader/index.js'
import errorHandlerShow from '../errorHandlerShow/index.js'
import SelectWithValidation from '../fields/selectWithValidation/index.js'
import SelectWithValidationInfo from '../fields/selectWithValidationInfo/index.js'
import ControlWithValidation from '../fields/controlWithValidation/index.js'
import ControlAreaWithValidation from '../fields/controlAreaWithValidation/index.js'
import ControlWithValidationInfo from '../fields/controlWithValidationInfo/index.js'

// schema validation
import * as schema from '../schemaValidation/index.js'

import './styles.css'

// constant for action status => edit manual file
const KEY_EDIT = 'EditAndShow'

const ManualFileForm = ({
    setAlert,
    setShowAlert,
    action,
    readOnly,
    fields,
    setFields,
    data,
    setData,
    setLgShow
}) => {
    // create object history
    const history = useHistory();

    const { pk_user, pk_service, token, setToken, displayName } = useContext(StoreContext);

    // variable used for control state of the form 
    const [status, setStatus] = useState("0")
    const [loading, setLoading] = useState(false);
    const [existingFileNames, setExistingFileNames] = useState([])
    const navegation = {
        'nome': 'consultar',
        'link': '/cadastro-arq-manual/consultar'
    }

    useEffect(() => {
        api.get('manual-file/metadata', {
            params: { 'pk_user': pk_user },
            headers: { 'Authorization': token }
        }).then(response => {
            setExistingFileNames(response.data.control_metadata.map((item, index) => (item.metadata.entity_name)))
        })
            .catch(error => {
                errorHandlerShow(error, setToken, setAlert, setShowAlert)
            })
    }, []);


    const checkFileName = ({ entity_name }) => {
        let response = true
        const char_whitelist = /[^a-zA-Z0-9_]/g

        if (entity_name !== undefined) {
            console.log(char_whitelist.test(entity_name))
            if (char_whitelist.test(entity_name) === true) {
                setAlert({
                    header: 'Ops... Houve algum problema',
                    message: 'O nome de arquivo só pode conter letras (sem acento), numeros e sublinhado/underline (_)',
                    type: 'danger',
                    options_btn: []
                })
                setShowAlert(true)
                response = false
            }

            if (existingFileNames.includes(entity_name)) {
                setAlert({
                    header: 'Ops... Houve algum problema',
                    message: 'O nome de arquivo especificado ja foi utilizado. Por favor insira outro nome',
                    type: 'danger',
                    options_btn: []
                })

                setShowAlert(true)
                response = false
            }
        }

        return response

    }

    const checkStageResponsible = ({ responsibles }) => {
        let response = true
        if (responsibles !== undefined) {
            const countResponsible = responsibles.length

            if (countResponsible < 2) {
                setAlert({
                    header: 'Ops... ficou faltando algumas informações',
                    message: 'Por gentileza, adicione pelos menos dois responsáveis de negócio. \
                    Use o botão adicionar pra acrescentar um novo responsável. \
                    Obs.: Inserir e-mails válidos, pois serão usados para comunicação dos status do processo.',
                    type: 'danger',
                    options_btn: []
                })

                setShowAlert(true)
                response = false
            }
        }

        return response
    }


    /**
     * save fields of the forms to data
     */
    const onSubmitManualFile = (forms) => {
        const isValidated = checkStageResponsible(forms) && checkFileName(forms)

        if (isValidated) {
            // define current state 
            setStatus((parseInt(status) + 1).toString())
            // add fields of the forms to data
            setData({ ...data, ...forms })

            // if (action === KEY_EDIT) {
            //     onEditManualFile(forms)
            // }

        }
    }

    const getStageResponsible = ({ responsibles }) => {
        let area = ''
        let email = ''
        let name = ''
        const countResponsible = responsibles.length

        responsibles.map((item, index) => {
            const delimiter = (countResponsible - 1 === index) ? '' : ';'
            area = area + item.area + delimiter
            email = email + item.email + delimiter
            name = name + item.name + delimiter
        })

        return { area_for_business_data: area, email_notification_account: email.replace(/\s+/g, ''), responsible_for_business_data: name }
    }

    /**
     * back to previous forms
     */
    const handleRollback = () => {
        setStatus((parseInt(status) - 1).toString())
    }

    /**
     * check if data it's ok
     */
    const checkData = () => {
        let hasError = true

        // check if all fields it's ok
        if (fields.filter(item => item.status === false).length > 0) {
            setAlert({
                header: 'Ops... ficou faltando algumas informações',
                message: 'Complete as informações de cada campo, use o icone lápis para editar a linha. \
                Após finalizado, salve novamente. \
                Obs.: Note que a coluna status deve estar com status ok',
                type: 'danger',
                options_btn: []
            })

            // show alert to users
            setShowAlert(true)
            // check if fields have at least one field
        } else if (fields.length <= 0) {
            setAlert({
                header: 'Ops... ficou faltando algumas informações',
                message: 'O arquivo precisa ter pelo menos um campo, adicione e salve novamente. \
                Obs.: Note que a coluna status deve estar com status ok',
                type: 'danger',
                options_btn: []
            })

            // show alert to users
            setShowAlert(true)
            // otherwise save manual file
        } else {
            hasError = false
        }

        return !hasError
    }

    const onCreateNewManualFile = () => {
        let checked = false
        console.log(data)
        if (data.project_name === "ipl_sustentabilidade" && data.extension_file === "xlsx") {
            checked = true
        } else {
            checked = checkData()
        }

        setLoading(true)

        if (checked) {
            const { area_for_business_data, email_notification_account, responsible_for_business_data } = getStageResponsible(data)
            const fields_custom = fields.map(({
                id,
                status,
                booleanFalse,
                booleanTrue,
                delimiterDate,
                delimiterDateTime,
                delimiterTime,
                month,
                sequence,
                sample_mask,
                ...myfield
            }) => myfield)
            const data_custom = {
                ...data, area_for_business_data: area_for_business_data,
                email_notification_account: email_notification_account,
                responsible_for_business_data: responsible_for_business_data
            }

            // call POST request to save manual file
            api.post('manual-file/metadata', { 'data': data_custom, 'fields': fields_custom }, {
                params: { 'pk_user': pk_user },
                headers: { 'Authorization': token }
            })
                .then(response => {
                    setAlert({
                        header: 'Cadastro do arquivo manual realizada com sucesso.',
                        message: response.data.message,
                        type: 'success',
                        options_btn: []
                    })

                    // show alert to users
                    setShowAlert(true)
                    setLoading(false)

                    // redirect users to /cadastro-arq-manual page after 10 seconds
                    setTimeout(() => {
                        history.push(`/cadastro-arq-manual?service_id=${pk_service}`)
                    }, 10000)
                })
                .catch(error => {
                    errorHandlerShow(error, setToken, setAlert, setShowAlert)
                    setLoading(false)
                })
        } else {
            setLoading(false)
        }
    }

    const onEditManualFile = (forms) => {
        setLoading(true)

        const checked = checkData()
        const isValidated = checkStageResponsible(forms)

        if (checked && isValidated) {
            const { area_for_business_data, email_notification_account, responsible_for_business_data } = getStageResponsible(forms)
            const fields_custom = fields.map(({
                id,
                status,
                booleanFalse,
                booleanTrue,
                delimiterDate,
                delimiterDateTime,
                delimiterTime,
                month,
                sequence,
                sample_mask,
                ...myfield
            }) => myfield)
            const data_custom = {
                ...data,
                ...forms,
                area_for_business_data: area_for_business_data,
                email_notification_account: email_notification_account,
                responsible_for_business_data: responsible_for_business_data
            }

            // call PUT request to save manual file
            api.put('manual-file/metadata', { 'data': data_custom, 'fields': fields_custom }, {
                params: { 'pk_user': pk_user },
                headers: { 'Authorization': token }
            })
                .then(response => {
                    setAlert({
                        header: 'Edição do arquivo manual realizada com sucesso.',
                        message: response.data.message,
                        type: 'success',
                        options_btn: []
                    })

                    // show alert to users
                    setShowAlert(true)
                    setLoading(false)
                    setLgShow(false)
                })
                .catch(error => {
                    errorHandlerShow(error, setToken, setAlert, setShowAlert)
                    setLoading(false)
                })
        } else {
            setLoading(false)
        }
    }

    return (
        <div>
            {action === KEY_EDIT ?
                <EditAndShowManualFile
                    data={data}
                    fields={fields}
                    action={action}
                    setFields={setFields}
                    readOnly={readOnly}
                    setAlert={setAlert}
                    setShowAlert={setShowAlert}
                    handleRollback={handleRollback}
                    onEditManualFile={onEditManualFile}
                    manualFileSchema={schema.manualFileSchema}
                    loading={loading} />
                :
                <CreateManualFile
                    status={status}
                    fields={fields}
                    setFields={setFields}
                    setAlert={setAlert}
                    setShowAlert={setShowAlert}
                    handleRollback={handleRollback}
                    onCreateNewManualFile={onCreateNewManualFile}
                    onSubmitManualFile={onSubmitManualFile}
                    loading={loading}
                    data={data}
                    displayName={displayName}
                    pk_user={pk_user}
                />
            }

        </div>
    );
}

const CreateManualFile = ({
    status,
    fields,
    setFields,
    setAlert,
    setShowAlert,
    handleRollback,
    onCreateNewManualFile,
    onSubmitManualFile,
    loading,
    data,
    pk_user,
    displayName
}) => (
    <Accordion defaultActiveKey="0" activeKey={status} className="mf-register-accordion">
        <Accordion.Item eventKey="0" >
            <Accordion.Header>Informações do solicitante</Accordion.Header>
            <Accordion.Body>
                <ManualFileFormRequesting
                    requestingSchema={schema.requestingSchema}
                    onSubmitManualFile={onSubmitManualFile}
                    pk_user={pk_user}
                    displayName={displayName}
                />
            </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
            <Accordion.Header>Responsáveis e definições</Accordion.Header>
            <Accordion.Body>
                <ManualFileFormResponsible
                    definitionSchema={schema.definitionSchema}
                    handleRollback={handleRollback}
                    onSubmitManualFile={onSubmitManualFile} />
            </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
            <Accordion.Header>Informações do arquivo</Accordion.Header>
            <Accordion.Body>
                <ManualFileFormFile
                    fileSchema={schema.fileSchema}
                    handleRollback={handleRollback}
                    onSubmitManualFile={onSubmitManualFile}
                    project_name={data.project_name} />
            </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
            <Accordion.Header>Informações dos campos</Accordion.Header>
            <Accordion.Body>
                {(data.project_name !== 'ipl_sustentabilidade' && data.extension_file !== 'xlsx') ?
                    <TableFields
                        fields={fields}
                        setFields={setFields}
                        setAlert={setAlert}
                        setShowAlert={setShowAlert}
                        delimiter={data.delimiter} /> : null
                }
                <ButtonsBackSave
                    handleRollback={handleRollback}
                    onClick={onCreateNewManualFile}
                    loading={loading} />
            </Accordion.Body>
        </Accordion.Item>
    </Accordion>
)


/**
 * FORMS
 * define o formulario de requisção
 */
const EditAndShowManualFile = ({
    data,
    fields,
    setFields,
    setAlert,
    setShowAlert,
    action,
    manualFileSchema,
    onEditManualFile,
    readOnly,
    loading
}) => {


    const buildresponsibles = ({ email_notification_account, area_for_business_data, responsible_for_business_data }) => {
        let responsibles = []
        if (email_notification_account !== undefined && area_for_business_data !== undefined && responsible_for_business_data !== undefined) {
            const emails = email_notification_account.split(";")
            const areas = area_for_business_data.split(";")
            const names = responsible_for_business_data.split(";")

            responsibles = emails.map((item, index) => {
                return { "name": names[index], "email": item, "area": areas[index] }
            });
        }

        return responsibles
    }

    return (
        <Formik
            initialValues={{
                requesting_name: data.requesting_name,
                requesting_email: data.requesting_email,
                requesting_area: data.requesting_area,
                requesting_company: data.requesting_company,
                is_project: data.is_project,
                project_name: data.project_name,
                justification_ingestion: data.justification_ingestion,

                responsibles: buildresponsibles(data),
                // responsible_for_business_data: data.responsible_for_business_data, 
                // area_for_business_data: data.area_for_business_data, 
                company: data.company,
                domain_data: data.domain_data,
                subject_data: data.subject_data,
                public_data: data.public_data,

                entity_name: data.entity_name,
                desc_entity: data.desc_entity,
                extension_file: data.extension_file,
                delimiter: data.delimiter,
                encoding: data.encoding,
                maximum_data_history_time: data.maximum_data_history_time,
                maximum_data_history_time_unit: data.maximum_data_history_time_unit,
                frequency: data.frequency,
                type_load: data.type_load,
                sample_pattern_file: data.entity_name + "_20220525*." + data.extension_file,
            }}

            validationSchema={manualFileSchema}
            onSubmit={(values) => onEditManualFile(values)}
            validateOnChange={true}
            validateOnBlur={true}
            enableReinitialize
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                setValues,
                touched,
                isValid,
                errors,
            }) => (
                <Form noValidate onSubmit={handleSubmit} >

                    <h1 className='mf-header'>Informações do solicitante</h1>
                    <hr className="mf-row" />

                    <RowsRequesting
                        values={values}
                        errors={errors}
                        handleChange={handleChange}
                        readOnly={readOnly} />

                    <h1 className='mf-header'>Responsáveis e definições</h1>
                    <hr className="mf-row" />

                    <RowsResponsible
                        values={values}
                        setValues={setValues}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        readOnly={readOnly}
                    />

                    <h1 className='mf-header'>Informações do arquivo</h1>
                    <hr className="mf-row" />

                    <RowsFile
                        action={action}
                        values={values}
                        errors={errors}
                        handleChange={handleChange}
                        readOnly={readOnly}
                        project_name={data.project_name}
                    />

                    {(data.project_name !== 'ipl_sustentabilidade' && data.extension_file !== 'xlsx') ?
                    <div>
                        <h1 className='mf-header'>Informações dos campos</h1>
                        <hr className="mf-row" />
        
                        <TableFields
                            fields={fields}
                            setFields={setFields}
                            readOnly={readOnly}
                            setAlert={setAlert}
                            setShowAlert={setShowAlert}
                            delimiter={data.delimiter}
                            project_nama={data.project_name}
                        />
                    </div>
                    : null}
                    {!readOnly ?
                        <div className="mf-register-next mf-register-next-only">
                            <BtnLoader
                                loading={loading}
                                messageNotLoading="Salvar"
                                messageLoading="Salvando"
                                style={"btn-loader-135px"}
                                variant={"success"}
                                hasOnClick={false}
                            />
                        </div>
                        : null
                    }

                </Form>
            )}
        </Formik>
    )
}

/**
 * FORMS
 * define o formulario de requisção
 */
const ManualFileFormRequesting = ({ requestingSchema, onSubmitManualFile, pk_user, displayName }) => (
    <Formik
        initialValues={{
            requesting_name: displayName,
            requesting_email: pk_user,
            requesting_area: '',
            requesting_company: '',
            is_project: '',
            project_name: '',
            justification_ingestion: ''
        }}
        validationSchema={requestingSchema}
        onSubmit={(values) => onSubmitManualFile(values)}
        validateOnChange={true}
        validateOnBlur={true}
    >
        {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
        }) => (
            <Form noValidate onSubmit={handleSubmit}>

                <RowsRequesting
                    values={values}
                    errors={errors}
                    handleChange={handleChange} />

                <div className="mf-register-next mf-register-next-only">
                    <BtnNext text={"Próximo"} />
                </div>

            </Form>
        )}
    </Formik>
)

/**
 * FORMS
 * define o formulario de responsavel pelo arquivo
 */
const ManualFileFormResponsible = ({ definitionSchema, onSubmitManualFile, handleRollback }) => (
    <Formik
        initialValues={{
            // responsible_for_business_data: '',
            // area_for_business_data: '',
            responsibles: [],
            company: '',
            domain_data: '',
            subject_data: '',
            public_data: ''
        }}
        validationSchema={definitionSchema}
        onSubmit={(values) => onSubmitManualFile(values)}
        validateOnChange={true}
        validateOnBlur={true}
    >
        {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            setValues,
            touched,
            isValid,
            errors,
        }) => (
            <Form noValidate onSubmit={handleSubmit}>

                <RowsResponsible
                    values={values}
                    setValues={setValues}
                    errors={errors}
                    touched={touched}
                    handleChange={handleChange}
                />

                <ButtonsBackNext handleRollback={handleRollback} />

            </Form>
        )}
    </Formik>
)

/**
 * FORMS
 * define o formulario do arquivo
 */
const ManualFileFormFile = ({ fileSchema, onSubmitManualFile, handleRollback, project_name }) => (
    <Formik
        initialValues={{
            entity_name: '',
            desc_entity: '',
            extension_file: '',
            delimiter: '',
            encoding: 'utf_8',
            maximum_data_history_time: '',
            maximum_data_history_time_unit: 'Mês',
            frequency: '',
            type_load: '',
            sample_pattern_file: ''
        }}
        validationSchema={fileSchema}
        onSubmit={(values) => onSubmitManualFile(values)}
        validateOnChange={true}
        validateOnBlur={true}
    >
        {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
        }) => (
            <Form noValidate onSubmit={handleSubmit}>

                <RowsFile
                    values={values}
                    errors={errors}
                    handleChange={handleChange}
                    project_name={project_name} />

                <ButtonsBackNext handleRollback={handleRollback} />

            </Form>
        )}
    </Formik>
)

/**
 * ROWS FORM
 * rows to requesting form
 */
const RowsRequesting = ({ values, errors, handleChange, readOnly }) => (
    <div>
        <Row className="mb-3">

            <ControlWithValidation Col={Col}
                type="text"
                label="Nome do solicitante"
                name="requesting_name"
                placeholder="Entrar com nome do solicitante"
                value={values.requesting_name}
                error={errors.requesting_name}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <ControlWithValidation Col={Col}
                type="text"
                label="E-mail do solicitante"
                name="requesting_email"
                placeholder="Entrar com e-mail do solicitante"
                value={values.requesting_email}
                error={errors.requesting_email}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <ControlWithValidationInfo Col={Col}
                type="text"
                label="Area do solicitante e do VP"
                name="requesting_area"
                placeholder="Entrar com área do solicitante"
                value={values.requesting_area}
                error={errors.requesting_area}
                handleChange={handleChange}
                readOnly={readOnly}
                custom_style="select-tooltip"
                tooltip="Preencher com área do solicitante e do VP&#0010;Por exemplo.: Engenharia de dados/TI & DA&#0010;"
            />

        </Row>

        <Row className="mb-3">

            <SelectWithValidation
                key="requesting_company"
                Col={Col}
                type="text"
                label="Empresa solicitante"
                name="requesting_company"
                placeholder=""
                value={values.requesting_company}
                error={errors.requesting_company}
                handleChange={handleChange}
                options={["", "Natura", "Avon", "The body Shop", "Aesop"]}
                readOnly={readOnly}
            />

            <SelectWithValidation
                key="is_project"
                Col={Col}
                type="text"
                label="A ingestão é para projeto?"
                name="is_project"
                placeholder=""
                value={values.is_project}
                error={errors.is_project}
                handleChange={handleChange}
                options={["", "Não", "Sim"]}
                readOnly={readOnly}
            />

            <ControlWithValidation
                key="project_name"
                Col={Col}
                type="text"
                label="Nome do projeto"
                name="project_name"
                placeholder="Entrar com nome do projeto"
                value={values.project_name}
                error={errors.project_name}
                handleChange={handleChange}
                typeColumn="xs"
                valueColumn={7}
                readOnly={readOnly}
            />
        </Row>

        <Row className="mb-3">

            <ControlAreaWithValidation
                key="justification_ingestion"
                Col={Col}
                label="Justificativa da ingestão manual"
                name="justification_ingestion"
                placeholder="Digitar justificativa detalhada da ingestão do arquivo manual e explicar brevemente o processo o qual faz parte."
                value={values.justification_ingestion}
                error={errors.justification_ingestion}
                handleChange={handleChange}
                readOnly={readOnly}
            />
        </Row>
    </div>
)

/**
 * ROWS FORM
 * rows to responsible form
 */
const RowsResponsible = ({ values, setValues, errors, touched, handleChange, readOnly }) => (
    <div>
        <Row className="mb-3">

            {/* <ControlWithValidationInfo Col={Col}
                type="text"
                label="Nomes dos responsáveis de negócio"
                name="responsible_for_business_data"
                placeholder="Ex.: Nome 1 (Nome da área); Nome 2 (Nome da área)"
                value={values.responsible_for_business_data}
                error={errors.responsible_for_business_data}
                handleChange={handleChange}
                typeColumn="xs"
                valueColumn={7}
                readOnly={readOnly}
                custom_style="select-tooltip"
                tooltip="Colocar os nomes dos responsáveis pelas informações&#0010;de negócio do arquivo, seguido da área entre parênteses.&#0010;Separar cada nome e área por ponto e vírgula"
            />

            <ControlWithValidationInfo Col={Col}
                type="text"
                label="E-mails dos responsáveis de negócio"
                name="area_for_business_data"
                placeholder="Ex.: email1@natura.com; email2@natura.com"
                value={values.area_for_business_data}
                error={errors.area_for_business_data}
                handleChange={handleChange}
                readOnly={readOnly}
                custom_style="select-tooltip"
                tooltip="Colocar os e-mails dos responsáveis pelas informações&#0010;de negócio do arquivo, separados por ponto e vírgula."
            /> */}

            <ResponsibleFields
                values={values}
                setValues={setValues}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                readOnly={readOnly}
            />

        </Row>

        {/* Fonte do arquivo deve ser sempre Arquivo Manual */}
        <Row className="mb-3">

            <SelectWithValidation
                key="company"
                Col={Col}
                type="text"
                label="Empresa"
                name="company"
                placeholder=""
                value={values.company}
                error={errors.company}
                handleChange={handleChange}
                options={["", "Natura", "Avon", "The body Shop", "Aesop", "Natura&Co"]}
                typeColumn="xs"
                valueColumn={2}
                readOnly={readOnly}
            />

            <ControlWithValidationInfo Col={Col}
                type="text"
                label="Domínio dos dados"
                name="domain_data"
                placeholder=""
                value={values.domain_data}
                error={errors.domain_data}
                handleChange={handleChange}
                readOnly={readOnly}
                custom_style="select-tooltip"
                tooltip="Descrever qual domínio de dados o arquivo faz parte.&#0010;Ex: Vendas, Cadastro, Supply Chain, etc"
            />

            <ControlWithValidationInfo Col={Col}
                type="text"
                label="Assunto da fonte de origem"
                name="subject_data"
                placeholder=""
                value={values.subject_data}
                error={errors.subject_data}
                handleChange={handleChange}
                readOnly={readOnly}
                custom_style="select-tooltip"
                tooltip="Descrever o subdomínio/assunto o qual os dados do arquivo representam.&#0010;Considerando o domínio de dados como finanças&#0010;Alguns exemplos de subdomínios/assuntos possíveis:&#0010;Taxas, Crédito e Risco, Planejamento Financeiro, etc"
            />

        </Row>
        <Row className="mb-3">

            <ControlWithValidationInfo Col={Col}
                type="text"
                label="Público associado"
                name="public_data"
                placeholder=""
                value={values.public_data}
                error={errors.public_data}
                handleChange={handleChange}
                readOnly={readOnly}
                custom_style="select-tooltip"
                tooltip="Descrever qual o público retrato no arquivo&#0010;Ex: CN, CF, Colaborador, Representante, etc"
            />

            {/* <ControlWithValidation Col={Col}
                type="text"
                label="Usuários que deseja permissão ao arquivo (Incluir e-mail e área)"
                name="have_permission"
                placeholder="Incluir e-mails/áreas."
                value={values.have_permission}
                error={errors.have_permission}
                handleChange={handleChange}
                readOnly={readOnly}
                valueColumn={8}
            /> */}

            <Col xs={7} />

        </Row>

    </div>
)

/**
 * ROWS FORM
 * rows to file form
 */
const RowsFile = ({ values, errors, handleChange, readOnly, action, project_name }) => {
    values.sample_pattern_file = values.entity_name + "_20220525*." + values.extension_file
    var tooltip = "ATENÇÃO: Os nomes dos arquivos devem seguir este padrão:\n" + values.entity_name + "_20220525*." + values.extension_file + "\n20220525 representa a data de inclusão do arquivo;\nO caracter * é um coringa indicando um texto livre de controle,\n sendo opcional Ex.:\n" + values.entity_name + "_20220525." + values.extension_file + "\n" + values.entity_name + "_20220525_0001." + values.extension_file + " (_0001 representa número do arquivo)\n " + values.entity_name + "_20220525_202205." + values.extension_file + " (_202205 representa período do ciclo)"
    var encoding = [
        'ascii',
        'big5',
        'big5hkscs',
        'cp037',
        'cp273',
        'cp424',
        'cp437',
        'cp500',
        'cp720',
        'cp737',
        'cp775',
        'cp850',
        'cp852',
        'cp855',
        'cp856',
        'cp857',
        'cp858',
        'cp860',
        'cp861',
        'cp862',
        'cp863',
        'cp864',
        'cp865',
        'cp866',
        'cp869',
        'cp874',
        'cp875',
        'cp932',
        'cp949',
        'cp950',
        'cp1006',
        'cp1026',
        'cp1125',
        'cp1140',
        'cp1250',
        'cp1251',
        'cp1252',
        'cp1253',
        'cp1254',
        'cp1255',
        'cp1256',
        'cp1257',
        'cp1258',
        'euc_jp',
        'euc_jis_2004',
        'euc_jisx0213',
        'euc_kr',
        'gb2312',
        'gbk',
        'gb18030',
        'hz',
        'iso2022_jp',
        'iso2022_jp_1',
        'iso2022_jp_2',
        'iso2022_jp_2004',
        'iso2022_jp_3',
        'iso2022_jp_ext',
        'iso2022_kr',
        'latin_1',
        'iso8859_2',
        'iso8859_3',
        'iso8859_4',
        'iso8859_5',
        'iso8859_6',
        'iso8859_7',
        'iso8859_8',
        'iso8859_9',
        'iso8859_10',
        'iso8859_11',
        'iso8859_13',
        'iso8859_14',
        'iso8859_15',
        'iso8859_16',
        'johab',
        'koi8_r',
        'koi8_t',
        'koi8_u',
        'kz1048',
        'mac_cyrillic',
        'mac_greek',
        'mac_iceland',
        'mac_latin2',
        'mac_roman',
        'mac_turkish',
        'ptcp154',
        'shift_jis',
        'shift_jis_2004',
        'shift_jisx0213',
        'utf_32',
        'utf_32_be',
        'utf_32_le',
        'utf_16',
        'utf_16_be',
        'utf_16_le',
        'utf_7',
        'utf_8',
        'utf_8_sig'
    ]

    return (
        <div >
            <Row className="mb-3">

                <SelectWithValidation
                    key="frequency"
                    Col={Col}
                    type="text"
                    label="Periodicidade"
                    name="frequency"
                    placeholder=""
                    value={values.frequency}
                    error={errors.frequency}
                    handleChange={handleChange}
                    options={["", "Diário", "Semanal", "Quinzenal", "Ciclo", "Mensal", "Anual"]}
                    readOnly={readOnly}
                />

                <SelectWithValidationInfo
                    key="type_load"
                    Col={Col}
                    type="text"
                    label="Tipo da carga"
                    name="type_load"
                    placeholder=""
                    value={values.type_load}
                    error={errors.type_load}
                    handleChange={handleChange}
                    options={["", "Full", "Delta"]}
                    readOnly={readOnly}
                    custom_style="select-tooltip"
                    tooltip="Na carga full todos os registros estão presentes&#0010;no arquivo que está sendo ingerido, os arquivos&#0010;anteriores servem apenas como histórico.&#0010;.&#0010;Na carga delta o arquivo ingerido contem novos&#0010;registros ou uma atualização dos registros dos&#0010;arquivos existentes."
                />

                <Col xs={8} />
            </Row>
            <Row className="mb-3">

                <ControlWithValidation
                    Col={Col}
                    type="text"
                    label="Nome da entidade"
                    name="entity_name"
                    placeholder=""
                    value={values.entity_name}
                    error={errors.entity_name}
                    handleChange={handleChange}
                    readOnly={(action === KEY_EDIT) ? true : readOnly}
                />

                <SelectWithValidation
                    key="extension_file"
                    Col={Col}
                    type="text"
                    label="Extensão do arquivo"
                    name="extension_file"
                    placeholder=""
                    value={values.extension_file}
                    error={errors.extension_file}
                    handleChange={handleChange}
                    options={(project_name === "ipl_sustentabilidade") ? ["", "txt", "csv", "xlsx"] : ["", "txt", "csv"]}
                    typeColumn="xs"
                    valueColumn={2}
                    readOnly={readOnly}
                />

                {/* Deve ser não editável */}
                {/* <Col md>
                    <Form.Group as={Col} controlId="formGridEmail">
                        <Form.Label>Exemplo de entrado do arquivo</Form.Label>
                        <Form.Control
                            type="text"
                            label="Nome do padrão do arquivo"
                            name="sample_pattern_file"
                            value={values.sample_pattern_file}
                            placeholder={values.sample_pattern_file}
                            handleChange={handleChange}
                            disabled
                        />
                    </Form.Group>
                </Col> */}
                <ControlWithValidationInfo
                    key="sample_pattern_file"
                    Col={Col}
                    type="text"
                    label="Nome de exemplo do arquivo"
                    name="sample_pattern_file"
                    placeholder=""
                    value={values.sample_pattern_file}
                    error={errors.sample_pattern_file}
                    handleChange={handleChange}
                    readOnly={true}
                    custom_style="select-tooltip"
                    tooltip={tooltip}
                />

                <ControlWithValidation Col={Col}
                    type="text"
                    label="Delimitador"
                    name="delimiter"
                    placeholder=""
                    value={values.delimiter}
                    error={errors.delimiter}
                    handleChange={handleChange}
                    typeColumn="xs"
                    valueColumn={2}
                    readOnly={readOnly}
                />

                <SelectWithValidationInfo
                    key="encoding"
                    Col={Col}
                    type="text"
                    label="encoding"
                    name="encoding"
                    placeholder=""
                    value={values.encoding}
                    error={errors.encoding}
                    handleChange={handleChange}
                    options={encoding}
                    typeColumn="xs"
                    valueColumn={2}
                    readOnly={readOnly}
                    custom_style="select-tooltip"
                    tooltip="O Encoding (codificação), é basicamente o processo de tradução de uma sequência de bytes em caracteres,&#0010;o que permite que os dados dos arquivos sejam lidos corretamente"
                />

            </Row>
            <Row className="mb-3">

                <ControlWithValidation
                    Col={Col}
                    type="text"
                    label="Descrição da entidade"
                    name="desc_entity"
                    placeholder=""
                    value={values.desc_entity}
                    error={errors.desc_entity}
                    handleChange={handleChange}
                    readOnly={readOnly}
                />

                <Col xl={2}>
                    <Form.Group as={Col} controlId="maximum_data_history_time">
                        <Form.Label>Histórico dos dados</Form.Label>
                        <InputGroup className="mb-3">
                            <FormControl
                                type="text"
                                aria-label="Text input with dropdown button"
                                name="maximum_data_history_time"
                                value={values.maximum_data_history_time}
                                onChange={handleChange}
                                isInvalid={!!errors.maximum_data_history_time}
                                readOnly={readOnly}
                            />
                            <Form.Select
                                aria-label="Default select example"
                                name="maximum_data_history_time_unit"
                                value={values.maximum_data_history_time_unit}
                                onChange={handleChange}
                                isInvalid={!!errors.maximum_data_history_time_unit}
                                disabled={readOnly}
                            >
                                <option value=""></option>
                                <option value="Mês">Mês</option>
                                <option value="Ano">Ano</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                {errors.maximum_data_history_time_unit + "\n" + errors.maximum_data_history_time}
                            </Form.Control.Feedback>
                        </InputGroup>

                    </Form.Group>
                </Col>

            </Row>


        </div>
    )
}

/**
 * BUTTON BACK AND NEXT
 */
const ButtonsBackNext = ({ handleRollback }) => (
    <div className="mf-register-next">
        <BtnBack handleRollback={handleRollback} />
        <BtnNext text={"Próximo"} />
    </div>
)

/**
 * Buttons back and save
 */
const ButtonsBackSave = ({ handleRollback, onClick, loading }) => (
    <div className="mf-register-next">
        <BtnBack handleRollback={handleRollback} />
        {/* <BtnSave onClick={onClick} hasOnClick={true} /> */}

        <BtnLoader
            loading={loading}
            messageNotLoading="Salvar"
            messageLoading="Salvando"
            style={"btn-loader-135px"}
            variant={"success"}
            onClick={onClick}
            hasOnClick={true}
        />
    </div>
)


const ResponsibleFields = ({ values, setValues, errors, touched, handleChange, readOnly }) => {

    const onAddNewTag = () => {
        const responsibles = [...values.responsibles];
        responsibles.push({ name: '', email: '', area: '' })
        setValues({ ...values, responsibles });
    }

    const onRemoveTag = (index, item) => {
        const responsibles = values.responsibles.filter(function (value, index_, arr) {
            return index_ != index;
        });

        setValues({ ...values, responsibles });
    }

    return (
        <div className='ilr-container-tags'>
            <Row className="mb-3">
                <Form.Label>
                    {"Responsáveis de negócio "}
                    <OverlayTrigger
                        key={'top'}
                        placement={'top'}
                        overlay={
                            <Tooltip
                                className="select-tooltip"
                                style={{ whiteSpace: 'pre-line', textAlign: 'left' }}
                                id="tooltip-top">
                                {"Obrigatório ter pelo menos dois responsáveis\nAtenção: os e-mails devem ser válidos,\npois serão usado para comunicação dos status do processo."}
                            </Tooltip>
                        }
                    >
                        <button className='controlInfo-btn-tooltip'>
                            <GoInfo />
                        </button>
                    </OverlayTrigger>
                </Form.Label>
            </Row>

            <TagFieldWithoutLabel
                onRemoveTag={onRemoveTag}
                values={values}
                errors={errors}
                handleChange={handleChange}
                readOnly={readOnly}
                touched={touched}
            />
            {!readOnly ?
                <Button className='btn-icon-text btn-next' variant="light" onClick={onAddNewTag}>
                    Adicionar
                </Button>
                : null}
        </div>
    )
}


const TagFieldWithoutLabel = ({ onRemoveTag, values, errors, touched, readOnly }) => (
    <FieldArray name="responsibles">
        {() => (values.responsibles.map((tags, i) => {
            const tagsErrors = errors.responsibles?.length && errors.responsibles[i] || {};
            const tagsTouched = touched.responsibles?.length && touched.responsibles[i] || {};
            return (
                <div>
                    {i === 0 ?
                        <Row className="mb-3">
                            <Col md>
                                <label>Nome</label>
                            </Col>
                            <Col md>
                                <label>E-mail</label>
                            </Col>
                            <Col md>
                                <label>Área</label>
                            </Col>
                            <Col md />
                        </Row>
                        : null}

                    <Row className="mb-3">
                        <Col md>
                            <Field readOnly={readOnly} name={`responsibles.${i}.name`} type="text" className={'form-control' + (tagsErrors.name && tagsTouched.name ? ' is-invalid' : '')} />
                            <ErrorMessage name={`responsibles.${i}.name`} component="div" className="invalid-feedback" />
                        </Col>
                        <Col md>
                            <Field readOnly={readOnly} name={`responsibles.${i}.email`} type="text" className={'form-control' + (tagsErrors.email && tagsTouched.email ? ' is-invalid' : '')} />
                            <ErrorMessage name={`responsibles.${i}.email`} component="div" className="invalid-feedback" />
                        </Col>
                        <Col md>
                            <Field readOnly={readOnly} name={`responsibles.${i}.area`} type="text" className={'form-control' + (tagsErrors.area && tagsTouched.area ? ' is-invalid' : '')} />
                            <ErrorMessage name={`responsibles.${i}.area`} component="div" className="invalid-feedback" />
                        </Col>
                        <Col md>
                            {!readOnly ?
                                <Button className='btn-tag-remove-without-label' variant="light" onClick={() => onRemoveTag(i, tags)}>
                                    Remover
                                </Button>
                                : null}
                        </Col>
                    </Row>
                </div>
            );
        }))}
    </FieldArray>
)

export default ManualFileForm;
